import React__default from 'react';
import { Tooltip } from '@deal/components';
import MessageBubble from '../../../MessageBubble/index.js';
import MessageBubbleText from '../../../MessageBubbleText/index.js';
import Check from './check.svg.js';
import { ContactCollectionBusinessLeadComponent } from './ContactCollectionBusinessLead.generated.js';
import styles from './styles.css.js';

var BusinessContactCollection = function BusinessContactCollection(_a) {
  var message = _a.message,
      myself = _a.myself,
      richCard = _a.richCard;
  var leadId = richCard.leadId;
  return React__default.createElement(ContactCollectionBusinessLeadComponent, {
    variables: {
      id: leadId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var _b = data.lead,
          expert = _b.expert,
          consumer = _b.consumer;
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(MessageBubbleText, {
        myself: myself,
        message: message
      }, consumer.firstName ? "Hey " + consumer.firstName + "! " : "Hey! ", " Enjoying your conversation", expert.shortName ? " with " + expert.shortName + "?" : '?', " Get their help on go - anytime you want! You can turn off text alerts anytime by replying STOP"), React__default.createElement(MessageBubble, {
        message: message,
        className: styles.message
      }, React__default.createElement(Tooltip, {
        placement: "top",
        message: "This message was sent because the lead did not provide us with a phone number.\n                      If they add their phone number, they will receive your messages as texts on\n                      their phone."
      }), consumer.hasPhoneNumber ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles.successFormContent
      }, React__default.createElement("div", {
        className: styles.phoneFormIcon
      }, React__default.createElement(Check, {
        width: 32,
        height: 32
      })), React__default.createElement("div", {
        className: styles.phoneFormHeader
      }, "Success! The user entered their phone number"))) : React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
        className: styles.phoneFormContent
      }, React__default.createElement("div", {
        className: styles.phoneFormHeader
      }, "Enter your phone number"), React__default.createElement("div", {
        className: styles.phone
      }, "Phone number"), React__default.createElement("div", {
        className: styles.terms
      }, "Message and data rates may apply. By submitting, you authorize Curated.com to send you automated text messages to alert you of deals and activity from your expert. You can turn off text alerts anytime by replying STOP.")))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

export default BusinessContactCollection;
//# sourceMappingURL=index.js.map
